var Environment = /** @class */ (function () {
    function Environment() {
    }
    return Environment;
}());
export { Environment };
var UserInfo = /** @class */ (function () {
    function UserInfo() {
    }
    UserInfo.init = function (obj) {
        UserInfo.firstname = obj.name;
        UserInfo.surname = obj.surname;
        UserInfo.email = obj.email;
        UserInfo.id = obj.id;
        UserInfo.ttl = obj.ttl;
        UserInfo.birthdate = obj.birthdate;
        UserInfo.permissions = obj.permissions;
        if (!localStorage.getItem('uuid'))
            localStorage.setItem("uuid", Tools.generateUUID());
        UserInfo.uuid = localStorage.getItem('uuid');
    };
    UserInfo.isAdmin = function () {
        return UserInfo.permissions.includes(1000);
    };
    UserInfo.hasSidePanelAccess = function () {
        var list = [
            1000,
            1001,
            1002
        ];
        for (var i = 0; i < list.length; i++)
            if (UserInfo.permissions.includes(list[i]))
                return true;
        return false;
    };
    UserInfo.getData = function () {
        return {
            name: UserInfo.firstname,
            surname: UserInfo.surname,
            email: UserInfo.email,
            birthdate: UserInfo.birthdate,
            id: UserInfo.id
        };
    };
    UserInfo.ttl = 0;
    return UserInfo;
}());
export { UserInfo };
var TimeTools = /** @class */ (function () {
    function TimeTools() {
    }
    TimeTools.updateDomTime = function (dom_target) {
        var curent = new Date().getTime() / 1000;
        var diff = UserInfo.ttl - curent;
        var ct = new Date(null);
        ct.setSeconds(diff);
        $(dom_target).text(ct.toISOString().slice(11, 19));
    };
    TimeTools.createTTLEvent = function (dom_target) {
        TimeTools.updateDomTime(dom_target);
        setInterval(function () {
            TimeTools.updateDomTime(dom_target);
        }, 1000);
        setInterval(function () {
            // $.ajax({
            //     dataType: "json",
            //     url: Environment.uri+"auth",
            //     type: "GET",
            //     xhrFields: { withCredentials: true },
            //     success: result=>{
            //         console.log(result)
            //         if (result.has_data)
            //         {
            //             if (result.data.auth_state !== undefined && result.data.auth_state[0] == "AUTH_OK")
            //             {
            //                 UserInfo.ttl = result.data.auth_state[1].ttl
            //             } else {
            //                 location.reload()
            //             }
            //             TimeTools.updateDomTime(dom_target)
            //         }
            //     }
            // }) 
            $.getJSON(Environment.uri + "auth?ssid=" + Environment.ssid, function (result) {
                if (result.has_data) {
                    if (result.data.auth_state !== undefined && result.data.auth_state[0] == "AUTH_OK") {
                        UserInfo.ttl = result.data.auth_state[1].ttl;
                    }
                    else {
                        Environment.ssid = "";
                        sessionStorage.setItem("ssid", "");
                        location.reload();
                    }
                }
                TimeTools.updateDomTime(dom_target);
            });
        }, 5000);
    };
    return TimeTools;
}());
export { TimeTools };
var Tools = /** @class */ (function () {
    function Tools() {
    }
    Tools.generatePassword = function (len) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        var counter = 0;
        while (counter < len) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    };
    Tools.generateUUID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    return Tools;
}());
export { Tools };
